<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required, minValue } from "vuelidate/lib/validators";
import store from "@/state/store";
import Multiselect from "vue-multiselect";



export default {
  beforeRouteEnter(to, from, next) {
    const userType = store.getters["auth/getUser"].user_type;
    const permissions = store.getters["auth/permissions"];
    if ((userType === 1 || userType === 3) && permissions.includes("PAYROLL_CONFIG")) {
      next();
    } else {
      alert("You are not allowed to access this page. You will be redirected.");
      next("/");
    }
  },
  page: {
    title: "Tax Reliefs",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {Multiselect, Layout, PageHeader },
  mounted() {
    this.refreshTable();
    this.getEmployees();
    this.getReliefTypes();
    },
  validations: {
    empId: { required },
    reliefTypeId: { required, minValue: minValue(1) },
    reliefAmount: { required, minValue: minValue(0) },
  },
  methods: {
    async uploadToS3(file) {
      const { data } = await this.apiPost("/s3/presigned-url", {
        fileName: file.name,
        fileType: file.type,
      });

      await fetch(data.uploadURL, {
        method: "PUT",
        headers: {
          "Content-Type": file.type,
        },
        body: file,
      });

      return data.fileUrl;
    },
    onFiltered(filteredItems) { this.totalRows = filteredItems.length; this.currentPage = 1; },

    async refreshTable() {
      await this.apiGet(this.ROUTES.taxRelief, "Get Tax Reliefs Error")
        .then((res) => {
          this.taxReliefs = res.data.map((tr, i) => ({
            sn: i + 1,
            id: tr.id,
            emp_id: tr.emp_id,
            employee_name: tr.employee
              ? `${tr.employee.emp_first_name} ${tr.employee.emp_last_name} (${tr.employee.emp_unique_id})`
              : "N/A",
            relief_type_id: tr.relief_type_id,
            relief_type_name: tr.reliefType
              ? tr.reliefType.relief_name
              : "N/A",
            amount_provided: tr.amount_provided,
            relief_amount: tr.relief_amount,
            start_date: tr.start_date,
            end_date: tr.end_date,
            status: tr.status,
            _raw: tr,
          }));
          this.totalRows = this.taxReliefs.length;
        });
    },
    onBulkFileChange() {
      const fileInput = this.$refs.bulkFile;
      if (fileInput && fileInput.files.length > 0) {
        this.bulkFile = fileInput.files[0];
      }
    },

    async submitBulkUpload() {
      if (!this.bulkFile) {
        return alert("Please select an Excel file to upload.");
      }

      const formData = new FormData();
      formData.append("file", this.bulkFile);

      try {
        const res = await this.apiPost(
          `${this.ROUTES.taxRelief}/bulk-upload`,
          formData,
          "Bulk Upload Error",
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        this.apiResponseHandler(
          res.data.message || "Bulk upload completed",
          "Bulk Upload"
        );

        this.refreshTable();
        this.resetForm();
        this.$refs["bulk-upload-relief"].hide();
      } catch (err) {
        console.error("Bulk upload failed:", err);
        alert("Bulk upload failed. Please check the console for details.");
      }
    },

    selectRelief(tr) {
      tr = tr[0];

      // bind multiselects correctly
      this.empId = this.employees.find(e => e.value == tr.emp_id) || null;
      this.reliefTypeId = this.relief_types.find(r => r.value == tr.relief_type_id) || null;

      this.amountProvided = tr.amount_provided;
      this.reliefAmount = tr.relief_amount;
      this.startDate = tr.start_date ? tr.start_date.substr(0, 10) : null;
      this.endDate = tr.end_date ? tr.end_date.substr(0, 10) : null;
      this.document = tr.document;
      this.status = tr.status;
      this.reliefID = tr.id;

      this.$refs["update-relief"].show();
      this.$refs["relief-table"].clearSelected();
    },

    resetForm() {
      this.empId = "";
      this.reliefTypeId = null;
      this.amountProvided = 0;
      this.reliefAmount = 0;
      this.startDate = null;
      this.endDate = null;
      this.document = "";
      this.status = null;
      this.attachment = null;

      if (this.$refs.file) {
        this.$refs.file.value = null;
      }

      this.$v.$reset();
    },
    submitAdd() {
      this.submitted = true;
      const formData = new FormData();
      formData.append("emp_id", this.empId.value);
      formData.append("relief_type_id", this.reliefTypeId.value);
      formData.append("amount_provided", this.amountProvided);
      formData.append("relief_amount", this.reliefAmount);
      formData.append("start_date", this.startDate);
      formData.append("end_date", this.endDate);
      formData.append("status", this.status);

      if (this.document) {
        formData.append("document", this.document);
      }

      this.apiPost(
        `${this.ROUTES.taxRelief}/add-tax-relief`,
        formData,
        "Add Tax Relief Error",
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      ).then(res => {
        this.apiResponseHandler(res.data.message, "Tax Relief Added");
        this.refreshTable();
        this.$v.$reset();
        this.resetForm();
        this.$refs["add-relief"].hide();
      });
    },

    filesChange(){
      this.document = this.$refs.file.files[0];
    },

    submitUpdate() {
      this.submitted = true;
      //this.$v.$touch();
     // if (this.$v.$invalid) return;

      const data = {
        emp_id: this.empId.value,
        relief_type_id: this.reliefTypeId.value,
        amount_provided: this.amountProvided,
        relief_amount: this.reliefAmount,
        start_date: this.startDate,
        end_date: this.endDate,
        document: this.document,
        status: this.status,
      };

      this.apiPatch(
        `${this.ROUTES.taxRelief}/${this.reliefID}`,
        data,
        "Update Tax Relief Error"
      ).then(res => {
        this.apiResponseHandler(res.data.message, "Update Successful");
        this.refreshTable();
        this.$refs["update-relief"].hide();
      });
    },

    submitDelete(id) {
      if (!confirm("Are you sure you want to delete this tax relief?")) return;
      this.apiDelete(`${this.ROUTES.taxRelief}/${id}`, "Delete Tax Relief Error")
        .then(res => {
          this.apiResponseHandler(res.data.message, "Deleted Successfully");
          this.refreshTable();
        });
    },
    employeeAsLabel({ text }) {
      return `${text}`;
    },
    getEmployees() {
      const url = `${this.ROUTES.employee}`;
      this.apiGet(url, "Get Employees Error").then((res) => {
        const { data } = res;
        data.map(emp=>{
          this.employees.push({
            value: emp.emp_id,
            text: `${emp.emp_first_name} ${emp.emp_last_name} (${emp.emp_unique_id})`,
          })
        });
      });
    },
    viewRelief(item) {
      this.viewingRelief = item;
      this.$refs["view-relief"].show();
    },
    downloadDocument(url) {
      if (!url) return;
      window.open(url, "_blank");
    },
    getReliefTypes() {
      const url = `${this.ROUTES.reliefType}`;
      this.apiGet(url, "Get Relief Type Error").then((res) => {
        const { data } = res;
        data.map(re=>{
          this.relief_types.push({
            value: re.id,
            text: `${re.relief_name} `,
          })
        });
      });
    },
  },
  data() {
    return {
      title: "Tax Reliefs",
      items: [
        { text: "IHUMANE" },
        { text: "Dashboard", href: "/" },
        { text: "Tax Reliefs", active: true },
      ],
      viewingRelief: null,
      taxReliefs: [],
      bulkFile: null,
      chosen_employee:null,
      employees:[],
      chosen_relief_type:null,
      relief_types:[],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "sn",
      sortDesc: false,
      fields: [
        { key: "sn", label: "S/N", sortable: true },
        { key: "employee_name", label: "Employee", sortable: true },
        { key: "relief_type_name", label: "Relief Type", sortable: true },
        { key: "amount_provided", label: "Amount Provided", sortable: true },
        { key: "relief_amount", label: "Relief Amount", sortable: true },
        { key: "start_date", label: "Start Date", sortable: true },
        { key: "end_date", label: "End Date", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      empId: "",
      reliefTypeId: null,
      amountProvided: 0,
      reliefAmount: 0,
      startDate: null,
      endDate: null,
      document: "",
      status: null,
      reliefID: null,
      submitted: false,
    };
  },
  filters: {
    date(value) {
      if (!value) return "-";
      return new Date(value).toLocaleDateString();
    },
  },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <scale-loader v-if="apiBusy" />
    <div v-else>
      <div class="btn-group">
        <div class="d-flex justify-content-between align-items-start mb-3 mr-2 flex-lg-row flex-column">
          <b-button class="btn btn-success" @click="$refs['add-relief'].show()">
            <i class="mdi mdi-plus mr-2"></i> Add Tax Relief
          </b-button>
        </div>

        <div class="d-flex justify-content-between align-items-start mb-3 flex-lg-row flex-column">
          <b-button class="btn btn-primary" @click="$refs['bulk-upload-relief'].show()">
            <i class="mdi mdi-file-excel mr-2"></i> Upload Tax Relief
          </b-button>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="row mt-4">
            <div class="col-sm-12 col-md-6">
              <label class="d-inline-flex align-items-center">
                Show&nbsp;
                <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
              </label>
            </div>
            <div class="col-sm-12 col-md-6 text-md-right">
              <label class="d-inline-flex align-items-center">
                Search:
                <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ml-2"/>
              </label>
            </div>
          </div>

          <b-table
            ref="relief-table"
            :items="taxReliefs"
            :fields="fields"
            selectable
            hover
            bordered
            responsive="sm"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :filter="filter"
            @filtered="onFiltered"
            select-mode="single"
            @row-selected="selectRelief"
          >
            <template #cell(start_date)="row">
              {{ row.item.start_date | date }}
            </template>

            <template #cell(end_date)="row">
              {{ row.item.end_date | date }}
            </template>

            <template #cell(status)="row">
  <span
    class="badge"
    :class="row.item.status === 1 ? 'badge-success' : 'badge-secondary'"
  >
    {{ row.item.status === 1 ? 'Active' : 'Inactive' }}
  </span>
            </template>

            <template #cell(actions)="row">
              <b-button size="sm"  variant="info" @click="viewRelief(row.item)">
                View
              </b-button>
              <b-button size="sm" class="mr-1" variant="primary" @click="selectRelief([row.item])">Edit</b-button>
              <b-button size="sm" variant="danger" class="ml-1" @click="submitDelete(row.item.id)">Delete</b-button>
            </template>
          </b-table>

          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="mt-3 float-right"></b-pagination>
        </div>
      </div>
    </div>

    <!-- Add / Update Modal -->
    <b-modal ref="add-relief" title="Add Tax Relief" hide-footer centered @hidden="resetForm">
      <form @submit.prevent="submitAdd">
        <b-form-group>
          <label for="">Employee *</label>
          <multiselect
            v-model="empId"
            :options="employees"
            :custom-label="employeeAsLabel"
            :multiple="false"
          ></multiselect>
        </b-form-group>
        <b-form-group>
          <label for="">Relief Type *</label>
          <multiselect
            v-model="reliefTypeId"
            :options="relief_types"
            :custom-label="employeeAsLabel"
            :multiple="false"
          ></multiselect>
        </b-form-group>
        <div class="form-group"><label>Amount Provided *</label><input type="number" step="0.01" v-model="amountProvided" class="form-control"/></div>
        <div class="form-group"><label>Relief Amount *</label><input type="number" step="0.01" v-model="reliefAmount" class="form-control" :class="{ 'is-invalid': submitted && $v.reliefAmount.$error }"/></div>
        <div class="form-group"><label>Start Date</label><input type="date" v-model="startDate" class="form-control"/></div>
        <div class="form-group"><label>End Date</label><input type="date" v-model="endDate" class="form-control"/></div>

        <div class="form-group">
          <label for="attachment">
            Document <span class="text-danger"></span>
          </label>
          <input
            id="attachment"
            type="file"
            name="attachment"
            ref="file"
            @change="filesChange()"
            class="form-control-file"
          />
        </div>


        <div class="form-group"><label>Status</label><b-form-select v-model="status" :options="[{value:1,text:'Active'},{value:0,text:'Inactive'}]"/></div>
        <b-button type="submit" class="btn btn-success btn-block mt-3">Submit</b-button>
      </form>
    </b-modal>

    <b-modal
      ref="update-relief"
      title="Update Tax Relief"
      hide-footer
      centered
      @hidden="resetForm"
    >
      <form @submit.prevent="submitUpdate">
        <b-form-group>
          <label>Employee *</label>
          <multiselect
            v-model="empId"
            :options="employees"
            :custom-label="employeeAsLabel"
            :multiple="false"
            :class="{ 'is-invalid': submitted && $v.empId.$error }"
          />
        </b-form-group>
        <b-form-group>
          <label>Relief Type *</label>
          <multiselect
            v-model="reliefTypeId"
            :options="relief_types"
            :custom-label="employeeAsLabel"
            :multiple="false"
            :class="{ 'is-invalid': submitted && $v.reliefTypeId.$error }"
          />
        </b-form-group>
        <div class="form-group">
          <label>Amount Provided *</label>
          <input
            type="number"
            step="0.01"
            v-model="amountProvided"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label>Relief Amount *</label>
          <input
            type="number"
            step="0.01"
            v-model="reliefAmount"
            class="form-control"
            :class="{ 'is-invalid': submitted && $v.reliefAmount.$error }"
          />
        </div>
        <div class="form-group">
          <label>Start Date</label>
          <input
            type="date"
            v-model="startDate"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label>End Date</label>
          <input
            type="date"
            v-model="endDate"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label>Document</label>
          <input
            type="text"
            v-model="document"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label>Status</label>
          <b-form-select
            v-model="status"
            :options="[
          { value: 1, text: 'Active' },
          { value: 0, text: 'Inactive' }
        ]"
          />
        </div>
        <b-button
          type="submit"
          class="btn btn-success btn-block mt-3"
        >
          Update
        </b-button>
      </form>
    </b-modal>

    <!-- Bulk Upload Modal -->
    <b-modal ref="bulk-upload-relief" title="Bulk Upload Tax Reliefs" hide-footer centered @hidden="resetForm">
      <form @submit.prevent="submitBulkUpload">
        <div class="form-group">
          <label for="bulk-file">Upload Excel File *</label>
          <input
            id="bulk-file"
            type="file"
            accept=".xlsx,.xls"
            ref="bulkFile"
            @change="onBulkFileChange"
            class="form-control-file"
            required
          />
        </div>

        <b-button type="submit" class="btn btn-success btn-block mt-3">Upload</b-button>
      </form>
    </b-modal>

    <b-modal
      ref="view-relief"
      title="View Tax Relief"
      hide-footer
      centered
    >
      <div v-if="viewingRelief">
        <p><strong>Employee:</strong> {{ viewingRelief.employee_name }}</p>
        <p><strong>Relief Type:</strong> {{ viewingRelief.relief_type_name }}</p>
        <p><strong>Amount Provided:</strong> {{ viewingRelief.amount_provided }}</p>
        <p><strong>Relief Amount:</strong> {{ viewingRelief.relief_amount }}</p>
        <p><strong>Start Date:</strong> {{ viewingRelief.start_date | date }}</p>
        <p><strong>End Date:</strong> {{ viewingRelief.end_date | date }}</p>

        <p>
          <strong>Status:</strong>
          <span
            class="badge"
            :class="viewingRelief.status === 1 ? 'badge-success' : 'badge-secondary'"
          >
        {{ viewingRelief.status === 1 ? 'Active' : 'Inactive' }}
      </span>
        </p>

        <div v-if="viewingRelief._raw && viewingRelief._raw.document">
          <b-button
            variant="success"
            class="mt-2"
            @click="downloadDocument(viewingRelief._raw.document)"
          >
            Download Attachment
          </b-button>
        </div>

        <div v-else class="text-muted mt-2">
          No attachment uploaded.
        </div>
      </div>
    </b-modal>


  </Layout>
</template>
